export default __webpack_public_path__ + "static/media/stopwatch_2.27a13155.svg";